export const basketGridColumns = [
  {
    title: 'Ações',
    type: 'checkbox',
    name: 'checked',
    width: '70px'
  },
  {
    "name": "Contrato",
    "title": "Contrato",
    width: 'calc(100% - 100px)',
  },
  // {
  //   "name": "contratoCancelado",
  //   "title": "Contrato Cancelado",
  //   "type": "input",
  //   width: '140px',
  // },
]